/**
 * Created by asiulik on 2016-11-18.
 */

define(function () {
    "use strict";

    //@todo target-asiulik update minWidth, maxWidth Values

    //#import
    //@implementation

    /**
     * DeviceTypeConst
     *
     * @name DeviceTypeConst
     *
     */
    var DeviceTypeConst = {};

    DeviceTypeConst.SMALL = {};
    DeviceTypeConst.SMALL.name = 'small';
    DeviceTypeConst.SMALL.maxWidth = 767;
    DeviceTypeConst.SMALL.minWidth = null;

    DeviceTypeConst.MEDIUM = {};
    DeviceTypeConst.MEDIUM.name = 'medium';
    DeviceTypeConst.MEDIUM.maxWidth = 1024;
    DeviceTypeConst.MEDIUM.minWidth = 768;

    DeviceTypeConst.LARGE = {};
    DeviceTypeConst.LARGE.name = 'large';
    DeviceTypeConst.LARGE.maxWidth = 1280;
    DeviceTypeConst.LARGE.minWidth = 1025;

    DeviceTypeConst.XL = {};
    DeviceTypeConst.XL.name = 'xl';
    DeviceTypeConst.XL.minWidth = 1280;
    DeviceTypeConst.XL.maxWidth = null;

    //Export
    return DeviceTypeConst;

    //@end
});



// WEBPACK FOOTER //
// ./Private/Scripts/const/devicetypeconst.js